import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      maxWidth: 700,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& h3': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      },

      '& p': {
        margin: theme.spacing(2, 0, 4),
        maxWidth: '80vw',

        [theme.breakpoints.up('sm')]: {
          margin: theme.spacing(2, 0, 5),
          width: '71%',
        },
        [theme.breakpoints.up('lg')]: {
          width: '65%',
        },
      },
    },

    formContainer: {
      textAlign: 'left',
      justifyContent: 'center',
    },
    formControl: {
      '& label:first-child': {
        top: 8,
      },
      '& label.Mui-focused': {
        top: 0,
        color: theme.palette.primary.light,
      },
      '& svg': {
        color: theme.palette.primary.light,
      },
      '& p': {
        margin: theme.spacing(1, 0),
        color: theme.palette.error.main,
      },
    },
  })
);

export default useStyles;
